import * as _ from "lodash";

var SamlSsoService = function (
    $resource,
    $http,
    $injector,
    $window,
    base64EncoderService,
    TransactionAccessRetrService,
    $q
) {
    var q = $q;

    return {
        getSamlSso: $resource(
            __baseApiUrl__ + "/participant-web-services/rest/sso/getSaml",
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                    }
                }
            }
        ),
        postSaml: function (url, data) {
            postForm(url, data, q);
        },
        postSamlSsoRequest: function (data, decode) {
            postRequest(data, this, $injector, $window, decode, base64EncoderService);
        },

        showSamlSso: function (txnCode, groupId, IndId, $injector) {
            return showTransaction(txnCode, groupId, IndId, TransactionAccessRetrService, q);
        }
    };
};

//Transforms the request data from the JSON format to parameter format
function transformJsonToFormData(data) {
    if (!angular.isObject(data)) {
        return data === null ? "" : data.toString();
    }
    var buffer = [];

    for (var name in data) {
        if (!data.hasOwnProperty(name)) {
            continue;
        }
        var value = data[name];
        buffer.push(
            encodeURIComponent(name) + "=" + encodeURIComponent(value === null ? "" : value)
        );
    }

    var transformed = buffer.join("&").replace(/%20/g, "+");
    return transformed;
}

function postForm(url, data, q) {
    var body = angular.element(document).find("body");
    var text = angular.element("<textarea></textarea>");

    text.attr("name", "SAMLResponse");
    text.val(data);

    var form = angular.element("<form></form>");
    form.attr("action", url);
    form.attr("method", "post");
    form.attr("target", "ssoWindow");

    form.on("submit", function (e) {
        e = e || window.event;
        var ssoWindow = window.open("about:blank", "ssoWindow");
        if (!ssoWindow || ssoWindow.closed || _.isUndefined(ssoWindow.closed)) {
            window.alert("Please disable your pop up blocker to view your account.");
            return false;
        }
        return true;
    });
    angular.element(form).appendTo(body);
    angular.element(text).appendTo(form);

    form.submit();
}

function postRequest(provider, service, $injector, $window, decode, base64EncoderService) {
    if (decode === null || decode === undefined) {
        decode = false;
    }

    var samlRequestData = {
        provider: provider
    };

    service.getSamlSso.query(samlRequestData).$promise.then(
        function (data, headers) {
            var posturl = null;
            var samlData = null;

            if (data.data === null || data.data === undefined) {
                posturl = data.url;
                samlData = data.saml;
            } else {
                posturl = data.data.url;
                samlData = data.data.saml;
            }

            if (decode) {
                samlData = base64EncoderService.decode(samlData);
            }

            var samlPostData = {
                SAMLResponse: samlData
            };

            service.postSaml(posturl, samlData);
        },
        function (error) {
            console.log(
                "SAML SSO Request Error: " + error.headers.status + " - " + error.headers.statusText
            );
            $injector
                .get(
                    "$state",
                    {},
                    {
                        reload: false
                    }
                )
                .go("genericError");
        }
    ); //End get SAML Function
}

function showTransaction(txnCode, groupId, IndId, TransactionAccessRetrService, q) {
    var deferred = q.defer();
    var transRequest = {
        txnCode: txnCode,
        individualId: IndId,
        groupId: groupId
    };
    var show = false;

    TransactionAccessRetrService.queryWithAccount(
        transRequest,

        //successful request
        function (response) {
            show = _.get(response, txnCode) === "true";
            deferred.resolve(show);
        },

        //request fails
        function (response) {
            console.log("SAML SSO Transaction request failed");
            return deferred.reject(response);
        }
    ); //End of query function

    return deferred.promise;
}

SamlSsoService.$inject = [
    "$resource",
    "$http",
    "$injector",
    "$window",
    "base64EncoderService",
    "TransactionAccessRetrService",
    "$q"
];
export default SamlSsoService;
